import {
  Component,
  OnInit,
  ElementRef,
  ViewEncapsulation,
  EventEmitter,
  Output,
  HostListener,
  ViewChild,
  Input,
} from '@angular/core';
import { PgExpandableFormCardComponent } from '../pg-expandable-form-card/pg-expandable-form-card.component';

@Component({
  selector: 'pg-reapply-card, grit-reapply-card',
  templateUrl: './pg-reapply-card.component.html',
  styleUrls: ['./pg-reapply-card.component.scss'],
  exportAs: 'pgReapplyCard',
  providers: [
    {
      provide: PgExpandableFormCardComponent,
      useExisting: PgReapplyCardComponent,
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PgReapplyCardComponent implements OnInit {
  locationPushState = false;
  expanded;
  @ViewChild(PgExpandableFormCardComponent, { static: true })
  expandableFormCard: PgExpandableFormCardComponent;

  @Input() originElement: ElementRef;

  @Output()
  expandChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {
    this.expandableFormCard.expandChange.subscribe(expanded => {
      if (expanded) {
        this.locationPushState = true;
        history.pushState({}, null, window.location.href);
      } else if (this.locationPushState) {
        history.back();
        this.locationPushState = false;
      }
      this.expanded = expanded;
      this.expandChange.emit(this.expanded);
    });
  }

  @HostListener('window:popstate')
  onPopstate() {
    if (this.expanded) {
      this.locationPushState = false;
      this.expandableFormCard.collapse();
    }
  }

  collapse() {
    return this.expandableFormCard.collapse();
  }
  expand() {
    return this.expandableFormCard.expand();
  }
}
